

import __layout_0 from '/var/www/vue/src/layouts/default.vue'
export const layouts = {
'blank': () => import('/var/www/vue/src/layouts/blank.vue'),
'default': __layout_0,
'components/DefaultLayoutWithHorizontalNav': () => import('/var/www/vue/src/layouts/components/DefaultLayoutWithHorizontalNav.vue'),
'components/DefaultLayoutWithVerticalNav': () => import('/var/www/vue/src/layouts/components/DefaultLayoutWithVerticalNav.vue'),
'components/Footer': () => import('/var/www/vue/src/layouts/components/Footer.vue'),
'components/NavBarI18n': () => import('/var/www/vue/src/layouts/components/NavBarI18n.vue'),
'components/NavBarNotifications': () => import('/var/www/vue/src/layouts/components/NavBarNotifications.vue'),
'components/NavTitle': () => import('/var/www/vue/src/layouts/components/NavTitle.vue'),
'components/NavbarShortcuts': () => import('/var/www/vue/src/layouts/components/NavbarShortcuts.vue'),
'components/NavbarThemeSwitcher': () => import('/var/www/vue/src/layouts/components/NavbarThemeSwitcher.vue'),
'components/UserProfile': () => import('/var/www/vue/src/layouts/components/UserProfile.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      meta: route.meta,
      component: layouts[route.meta?.layout || 'default'],
      children: route.path === '/' ? [route] : [{...route, path: ''}]
    }
  })
}
